import { config } from '../../../../../src/config';
import React, { useEffect, useMemo, useState } from 'react';
import ModifyAccountPopup from '../ModifyAccountPopup/ModifyAccountPopup';
import ModifyAdminPriviliges from '../ModifyAccountPrivileges/ModifyAccountPrivileges';
import { maskingToPlainNumber, validateEmail } from '../../../helper';
import axiosApi from '../../../../core/interceptor/interceptor';
import _ from 'lodash';
import { setPermission } from '../../../../Store/reducers/PermissionsReducer';
import { useDispatch } from 'react-redux';

export default function ModifyAccount(props) {
    /***** States of form ******/
    const [formData, setFormData] = useState({});
    /**** Show/Hide Priviliges *****/
    const [showPriviliges, setShowPriviliges] = useState(false);
    const [priviliges, setPriviliges] = useState([]);
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [emailExist, setEmailExist] = useState(false);
    const [checkingEmail, setCheckingEmail] = useState(false);
    const debouncedCheckEmailExistance = useMemo(
        () => _.debounce((email, id) => checkEmail(email, id), 1500),
        // eslint-disable-next-line
        [],
    );
    const dispatch = useDispatch();

    useEffect(() => {
        setFormData({ ...props.data, email_check: false });
        //eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (props.currentModifyPage) {
            props.currentModifyPage(showPriviliges)
        }
        //eslint-disable-next-line
    }, [showPriviliges]);

    /*** Show/Hide Priviliges  *****/
    const showPrivilige = (e) => {
        e.preventDefault();
        setFormSubmitted(true);
        if (
            !(formData.first_name || '').trim() ||
            !(formData.last_name || '').trim() ||
            !(formData.email || '').trim() ||
            (formData.cell_phone && formData.cell_phone.replace(/\D/g, '').length < 10) ||
            (formData.secondary_phone && formData.secondary_phone.replace(/\D/g, '').length < 10)
        ) {
            return;
        }

        if (!validateEmail((formData.email || '').trim()) || emailExist) {
            return;
        }
        setShowPriviliges(show => !show);
    }

    /**** Triggers when form submit *****/
    const handleSubmit = (event) => {
        event.preventDefault();
        setFormSubmitted(true);
        updateData();
    }

    /*** closes modal *****/
    const closeModal = (resp = false) => {
        if (props.closeModal) {
            props.closeModal(resp);
        }
    }

    /***** Triggers when form data changes ******/
    const handleFormChange = (event, checkEmail = false) => {
        setFormData((previousFormData) => ({
            ...previousFormData,
            [event.target.name]: event.target.value,
            check_email: checkEmail,
        }))
    }


    const getAndSetPermissions = () => {
		axiosApi.get(`${config.apiUrl}/permissions`)
			.then((response) => {
				if (response && response.data && response.data.data && response.data.data.length) {
					const slug = response.data.data.map(x => x.acl_permission && x.acl_permission.slug);
                    dispatch(setPermission(slug));
				}
			});
	}
    const updateData = () => {
        const data = formData;
        data['cell_phone'] = maskingToPlainNumber(data.cell_phone);
        data['secondary_phone'] = maskingToPlainNumber(data.secondary_phone);
        const oldPersmissions = props.data.acl_user_permissions.map(x => x.permission_id).sort();
        const newPermissions = [...priviliges].sort();
        const isSame = (oldPersmissions.length === newPermissions.length) && oldPersmissions.every((element, index) => {
            return element === newPermissions[index];
        });
        const obj = {
            first_name: (data.first_name || '').trim(),
            last_name: (data.last_name || '').trim(),
            email: (data.email || '').trim(),
            cell_phone: data.cell_phone,
            secondary_phone: data.secondary_phone,
            account_locked: data.account_locked,
            shirt_size: data.shirt_size,
        };

        if (
            !obj.first_name ||
            !obj.last_name ||
            !obj.email ||
            (obj.cell_phone && obj.cell_phone.replace(/\D/g, '').length < 10) ||
            (obj.secondary_phone && obj.secondary_phone.replace(/\D/g, '').length < 10)
        ) {
            return;
        }

        if (!validateEmail((data.email || '').trim()) || emailExist) {
            return;
        }

        if (!isSame && props.type === 'admin') {
            obj.permissions = newPermissions;
        }

        axiosApi.put(`${config.apiUrl}/users/${props.type}/${data.id}`, obj)
            .then((res) => {
                getAndSetPermissions();
                setFormSubmitted(false);
                closeModal(data);
            })
            .catch((err) => {
                setFormSubmitted(false);
                console.error(err);
            });
    }

    useEffect(() => {
        if (validateEmail(formData.email) && formData.check_email) {
            debouncedCheckEmailExistance(formData.email, formData.id);
        }
        //eslint-disable-next-line
    }, [formData.email]);

    const checkEmail = (email, id) => {
        setCheckingEmail(true);
        axiosApi.post(`${config.apiUrl}/misc/check-email-existance`, { email, id, user_type: props.type ? props.type : 'user' })
            .then((res) => {
                setEmailExist(!!res.data.data);
                setCheckingEmail(false);
            })
            .catch((err) => {
                console.error(err);
                setCheckingEmail(false);
            });
    }

    return <>
        <form onSubmit={handleSubmit}>
            {
                !showPriviliges
                    ? <ModifyAccountPopup checkingEmail={checkingEmail} formSubmitted={formSubmitted} formData={formData} type={props.type} handleFormChange={handleFormChange} emailExist={emailExist} />
                    : <ModifyAdminPriviliges permissions={setPriviliges} userId={formData.id} />
            }
            {
                !showPriviliges && props.type && props.type === 'admin'
                    ? (<div className="modal-footer d-flex">
                        <button className="cancel-btn" onClick={() => closeModal(props.data)}>Cancel</button>
                        <button type="button" onClick={(e) => {
                            showPrivilige(e);
                        }}>Continue to Priviliges</button>
                    </div>)
                    : <div className="modal-footer d-flex">
                        <button className="cancel-btn" onClick={props.type && props.type === 'admin' ? showPrivilige : () => closeModal(props.data)}>{props.type === 'admin' ? 'Back' : 'Cancel'}</button>
                        <button type="submit">Save Changes</button>
                    </div>
            }
        </form>
    </>
}